// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"166":"quiz","323":"lexique","443":"about","475":"directional","535":"login","700":"ipponkumite","845":"profile","987":"grades"}[chunkId] + "." + {"166":"4ace02ca","323":"1b7d9c41","443":"26ca18f8","475":"56e8b0cf","535":"b9612d47","700":"49901e9f","845":"eaac79d0","987":"4e0a639e"}[chunkId] + ".js";
};